import React, { useEffect } from 'react';
import { CheckCircle, XCircle, X } from 'lucide-react';

interface ToastProps {
  message: string;
  type: 'success' | 'error';
  onClose: () => void;
  duration?: number;
}

const Toast: React.FC<ToastProps> = ({
  message,
  type,
  onClose,
  duration = 3000,
}) => {
  useEffect(() => {
    const timer = setTimeout(() => {
      onClose();
    }, duration);

    return () => clearTimeout(timer);
  }, [duration, onClose]);

  const icon = type === 'success' ? (
    <CheckCircle className="text-green-400" size={20} />
  ) : (
    <XCircle className="text-red-400" size={20} />
  );

  const bgColor = type === 'success'
    ? 'bg-green-900/95 border-green-700/50'
    : 'bg-red-900/95 border-red-700/50';

  return (
    <div
      className="fixed bottom-8 right-8 z-50 animate-in slide-in-from-bottom-full duration-300"
      role="alert"
      aria-live="polite"
    >
      <div className={`${bgColor} backdrop-blur-md rounded-lg shadow-lg border max-w-sm`}>
        <div className="p-4 flex items-start">
          <div className="flex-shrink-0 mr-3">
            {icon}
          </div>
          <div className="flex-1">
            <div className="text-white text-sm font-medium whitespace-pre-wrap">{message}</div>
          </div>
          <button
            onClick={onClose}
            className="ml-3 flex-shrink-0 text-white/60 hover:text-white transition-colors"
          >
            <X size={16} />
          </button>
        </div>
      </div>
    </div>
  );
};

export default Toast;
